import React, { useRef, useState } from 'react';
import BtnSlider from './BtnSlider';
import dataSlider from './dataSlider';
import './Slider.css';
import { useSwipeable } from 'react-swipeable';

const Slider = ({ chg, imgAlt }) => {
  const [slideIndex, setSlideIndex] = useState(1);
  const lastWheelTime = useRef(0);
  const swipeCooldown = useRef(false); // prevent rapid swipes

  const nextSlide = () => {
    if (slideIndex !== dataSlider.length) {
      setSlideIndex(slideIndex + 1);
    } else {
      setSlideIndex(1);
    }
  };

  const prevSlide = () => {
    if (slideIndex !== 1) {
      setSlideIndex(slideIndex - 1);
    } else {
      setSlideIndex(dataSlider.length);
    }
  };

  const moveDot = (index) => {
    setSlideIndex(index);
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => {
      if (!swipeCooldown.current) {
        swipeCooldown.current = true;
        nextSlide();
        setTimeout(() => {
          swipeCooldown.current = false;
        }, 500); // 0.5s cooldown
      }
    },
    onSwipedRight: () => {
      if (!swipeCooldown.current) {
        swipeCooldown.current = true;
        prevSlide();
        setTimeout(() => {
          swipeCooldown.current = false;
        }, 500);
      }
    },
    preventScrollOnSwipe: true,
    trackMouse: true,
    trackTouch: true,
  });

  const handleWheel = (e) => {
    const now = Date.now();
    const threshold = 50; // more strict scroll threshold
    const cooldown = 600;

    if (now - lastWheelTime.current < cooldown) return;

    if (e.deltaX > threshold) {
      nextSlide();
      lastWheelTime.current = now;
    } else if (e.deltaX < -threshold) {
      prevSlide();
      lastWheelTime.current = now;
    }
  };

  return (
    <div {...handlers} onWheel={handleWheel}>
      <div className='container-slider h-[13rem] md:h-[18rem] lg:h-[23rem] 2xl:h-[31rem] pt-[4px]'>
        {dataSlider.map((obj, index) => (
          <div
            key={index}
            className={
              slideIndex === index + 1
                ? 'slide active-anim image-container w-full h-[96%] md:h-[98%]'
                : 'slide image-container w-full h-[98%]'
            }
          >
            <img
              srcSet={process.env.PUBLIC_URL + `/${chg}/img${index + 1}.webp`}
              alt={imgAlt}
              className='images object-contain w-full h-full'
            />
          </div>
        ))}

        <BtnSlider moveSlide={nextSlide} direction='next' />
        <BtnSlider moveSlide={prevSlide} direction='prev' />

        <div className='container-dots bottom-[-24px] md:bottom-[-37px] lg:bottom-[-38px]'>
          {Array.from({ length: dataSlider.length }).map((_, index) => (
            <button
            aria-label={`image slide ${index + 1}`}
              key={index}
              onClick={() => moveDot(index + 1)}
              className={
                slideIndex === index + 1
                  ? 'dot w-[15px] h-[15px] md:w-[20px] md:h-[20px] active'
                  : 'dot w-[15px] h-[15px] md:w-[20px] md:h-[20px]'
              }
            ></button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Slider;
